(function() {
  'use strict';

  // Check if config exists
  if (!window.iterableConfig) {
    return;
  }

  const config = window.iterableConfig;
  const FORM_ID = 'ContactPDP';
  const EMAIL_INPUT_ID = 'NewsletterFormPDP';

  // Helper function to capitalize first letter
  function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  function show(el) {
    if (el) {
      el.classList.remove('hidden');
    }
  }

  function hide(el) {
    if (el) {
      el.classList.add('hidden');
    }
  }

  // Resolve the status elements relative to the form. Handles both layouts:
  // form nested inside .main (status divs are siblings of .main), or the
  // form wrapping .main and the status divs.
  function resolveStatusElements(form) {
    const mainAncestor = form.closest('.main');
    const scope = mainAncestor ? mainAncestor.parentElement : form;

    return {
      main: mainAncestor || scope.querySelector('.main'),
      spinner: scope.querySelector('.loading__spinner'),
      thankYou: scope.querySelector('.thank-you'),
      error: scope.querySelector('.error')
    };
  }

  function sendIterableSignup(emailInput, form) {
    const email = emailInput.value.trim();

    if (!email || !config.apiUrl || !config.apiKey) {
      return;
    }

    // Build siteID and source
    const siteID = `${config.brand}_${config.region}`.toUpperCase();
    const source = `${capitalizeFirstLetter(config.brand)}_pdp`;

    // Use list endpoint if a list ID is provided
    const listId = form.querySelector('input[name="iterable_list_id"]')?.value;
    const useListEndpoint = Boolean(listId);

    // Build payload
    const payload = {
      requestType: useListEndpoint ? 'sendDataToIterableList' : 'sendDataToIterable',
      siteID: siteID,
      data: {
        email: email,
        country: config.countryName,
        countryCode: config.countryCode,
        source: source,
        marketingOptIn: true
      }
    };

    // Add listId if using list endpoint
    if (useListEndpoint) {
      payload.data.listId = listId;
    }

    // Show the loading state and hide the form while the request is in flight.
    const status = resolveStatusElements(form);
    hide(status.thankYou);
    hide(status.error);
    hide(status.main);
    show(status.spinner);

    fetch(`${config.apiUrl}/admin-actions`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': config.apiKey
      },
      body: JSON.stringify(payload)
    })
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Request failed with status ' + response.status);
        }
        hide(status.spinner);
        show(status.thankYou);
      })
      .catch(function() {
        hide(status.spinner);
        show(status.error);
      });
  }

  // Delegated submit handler catches forms injected after this script loads.
  document.addEventListener('submit', function(e) {
    const form = e.target;

    if (!(form instanceof HTMLFormElement) || form.id !== FORM_ID) {
      return;
    }

    const emailInput =
      form.querySelector(`#${EMAIL_INPUT_ID}`) ||
      document.getElementById(EMAIL_INPUT_ID);

    if (!emailInput) {
      return;
    }

    // Keep the flow on-page so the loading/thank-you/error states are visible.
    e.preventDefault();

    sendIterableSignup(emailInput, form);
  });
})();
